/** Queued or actively collecting. At most one of these per lineage. */
export const SITE_AUDIT_IN_PROGRESS_STATUSES = [
  "queued",
  "collecting_dataforseo",
  "collecting_pagespeed",
  "collecting_moz",
  "analyzing",
] as const;

/** Collecting or analysing. A normal delete refuses these. Queued jobs can be deleted. */
export const SITE_AUDIT_RUNNING_STATUSES = [
  "collecting_dataforseo",
  "collecting_pagespeed",
  "collecting_moz",
  "analyzing",
] as const;

/** Collecting or analysing with no heartbeat for this long is marked failed. Queued jobs are not included: Inngest runs one audit at a time, so queue wait is not stuck time. */
export const SITE_AUDIT_STUCK_AFTER_MS = 30 * 60 * 1000;

export type SiteAuditInProgressStatus = (typeof SITE_AUDIT_IN_PROGRESS_STATUSES)[number];

export function isSiteAuditInProgress(status: string): boolean {
  return (SITE_AUDIT_IN_PROGRESS_STATUSES as readonly string[]).includes(status);
}
